export enum AlertSeverity {
  Success = "success",
  Error = "error",
  Info = "info",
}
